export default __webpack_public_path__ + "static/media/telemed.df2174d1.png";